import axios from "axios";
import Environments from "../environments/Environment";

var http = null;

class APIProvider {
  constructor() {
    http = axios.create({
      baseURL: Environments.BASE_URL,
      headers: { "Content-Type": "application/json" }
    });
  }

  generateInsurance(data) {
    return new Promise((success, error) => {
      http.post("/insurances/generateInsurance", data).then(result => {
        if (result.data.status == 1) success(result.data);
        else error(result.data);
      });
    });
  }

  sendContact(data) {
    return new Promise((success, error) => {
      http.post("/user/create/contact", data).then(result => {
        if (result.data.status == 1) success(result.data);
        else error(result.data);
      });
    });
  }

  getModels() {
    return new Promise((success, error) => {
      http.get("/insurance/get/models").then(result => {
        if (result.data.status == 1) success(result.data);
        else error(result.data);
      });
    });
  }

  getBrands(data) {
    return new Promise((success, error) => {
      http.post("/insurance/get/brands", data).then(result => {
        if (result.data.status == 1) success(result.data);
        else error(result.data);
      });
    });
  }

  getVersions(data) {
    return new Promise((success, error) => {
      http.post("/insurance/get/versions", data).then(result => {
        if (result.data.status == 1) success(result.data);
        else error(result.data);
      });
    });
  }

  getDescriptions(data) {
    return new Promise((success, error) => {
      http.post("/insurance/get/descriptions", data).then(result => {
        if (result.data.status == 1) success(result.data);
        else error(result.data);
      });
    });
  }

  saveQuotation(data) {
    return new Promise((success, error) => {
      http.post("/insurance/create/quotation", data).then(result => {
        if (result.data.status == 1) success(result.data);
        else error(result.data);
      });
    });
  }

  getQuote(data) {
    return new Promise((success, error) => {
      http.post("/insurance/get/quote", data).then(result => {
        if (result.data.status == 1) success(result.data);
        else error(result.data);
      });
    });
  }

  quoteInsurance(data) {
    return new Promise((success, error) => {
      http.put("/insurance/get", data).then(result => {
        if (result.data.status == 1) success(result.data);
        else error(result.data);
      });
    });
  }

  scheduleCall(data) {
    return new Promise((success, error) => {
      http.put("/insurance/save/type_contact", data).then(result => {
        if (result.data.status == 1) success(result.data);
        else error(result.data);
      });
    });
  }

  getInsurce() {
    http.defaults.headers.common["session"] = localStorage.getItem("session");
    return new Promise((success, error) => {
      http.get("/insurance/get/insurce").then(result => {
        if (result.data.status == 1) success(result.data);
        else {
          if (result.data.code == 8) {
            localStorage.removeItem("session");
            location.reload();
          } else error(result.data);
        }
      });
    });
  }
}

export default new APIProvider();



// WEBPACK FOOTER //
// ./src/services/Insurance.js